import { render, staticRenderFns } from "./Capabilities.vue?vue&type=template&id=e241ebe0&"
import script from "./Capabilities.vue?vue&type=script&lang=js&"
export * from "./Capabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports